import React, { useEffect, useState, useContext } from "react";
import { formatDistanceToNow } from 'date-fns'
import { es, enUS } from 'date-fns/locale'
import { NavLink } from 'react-router-dom';
import Screen from '../components/Screen';
import { getCDNImage } from '../globals';
import { T } from "react-translator-component";
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';
import { UserContext } from "../context/user";
import { i18nValue } from '../functions';
import { HotelContext } from "../context/hotel";
import { BellNotification } from '../components/Icons';

const Notifications = () => {
  const [initialTab, setInitialTab] = useState('actives')
  const { sectionsByCode } = useContext(HotelContext);
  const { notifications, getNotifications, language } = useContext(UserContext);

  useEffect(() => {
    getNotifications();
  }, [])

  const Item = (item) => {
    const { pathname } = useLocation();
    const _createdAt = Date.parse(item.createdAt);
    const _ago = _createdAt ? formatDistanceToNow(_createdAt, { addSuffix: true, locale: language === 'es' ? es : enUS }) : null;
    let _message = item.payload?.message || "";
    if (item.content?.text) {
      _message = item.content.text;
    }
    return (
      <NavLink
        key={item.id}
        className={`list-group-item list-group-item-action flex-column align-items-start w-100 text-decoration-none ${item.unread ? 'item-unread' : ''}`}
        style={{ borderLeft: `3px solid ${item.unread ? 'red' : '#DDD'}` }}
        to={{ pathname: item.id }}
        state={{ from: pathname }}
      >
        <div className="d-flex py-2" >

          {item.content?.photo && <div className="mr-3" style={{ width: 40 }} >
            <img
              style={{ width: 40, maxHeight: 80 }}
              src={getCDNImage(item.content.photo)}
              className="product-item-photo rounded-lg"
              alt=""
            />
          </div>}

          {!item.content?.photo && <dix className="mr-3 text-center" style={{ width: 40 }}>
            {item.unread ?
              <div style={{ width: 40 }}><FontAwesomeIcon size="lg" style={{ fontSize: 28 }} icon={faEnvelope} className="text-danger" /></div> :
              <div style={{ width: 40 }}><FontAwesomeIcon size="lg" style={{ fontSize: 28 }} icon={faEnvelopeOpenText} /></div>}
          </dix>}

          <div>
            <div className="mb-2 general-text" style={{ lineHeight: 1 }}>
              {item.unread ?
                <div className="font-weight-bold">{item.payload?.title || item.content?.title || ""}</div> :
                <div>{item.payload?.title || item.content?.title || ""}</div>
              }
            </div>
            <div className="general-text text-muted text-left" style={{ lineHeight: 1.1, fontSize: 13 }}>
              {`${_message.substring(0, 150)} ${item.payload?.message?.length > 150 ? '...' : ''}` || ""}
            </div>
            <div className="general-text-sm text-mute mt-2">{_ago}</div>
          </div>

        </div>
      </NavLink>)

  }

  if (!initialTab) {
    return <p>Loading...</p>
  }

  return (
    <Screen
      section="notifications"
      title={i18nValue(sectionsByCode['notifications'], 'title', language) || "Notifications"}
      description={i18nValue(sectionsByCode['notifications'], 'desc', language)}
    >
      <div className="list-group mt-3">
        {notifications && notifications.length === 0 && <div className="w-100 text-center" style={{ marginTop: 70 }}>
          <BellNotification width={180} height={180} />
          <p className="mb-1 mt-2 font-weight-bold">{T('notifications.empty-title')}</p>
        </div>}
        {notifications && notifications.length > 0 && notifications.map(req => (Item(req)))}
      </div>
    </Screen>
  );
}

export default Notifications;